import Popup from "reactjs-popup";
import moment from "moment-timezone";
import TimezonePicker from "react-timezone";
import { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import {
  getCountries,
  updateUserInfo,
  getAdminUserInfo,
  getGlobalLanguages,
  getStudentManagement,
  updateStatusStudentB2B,
} from "../../store/middleware";
import PhotoAvatar from "../../components/PhotoAvatar";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import linguitoPNG from "../../assets/images/icons/linguito.png";
import ModalChangePassword from "../../components/ModalChangePassword";
import { timeDisplayFormat as timeDisplayFormatFunction } from "../../utils/utils";
import InputForClassTool from "../../components/elements/NewInputs/InputForClassTool";

import { PersonalInfoStyled } from "./styles";
import { SCButtonAddInput } from "../../components/Buttons/styles";

function PersonalInfo({ id }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, isAuthenticated } = useSelector((state) => state.userReducer);

  const [validations] = useState({});
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [idUser, setIdUser] = useState(0);
  const [gender, setGender] = useState("");
  const [address, setAddress] = useState("");
  const [cpnCode, setCpnCode] = useState("");
  const [subRole, setSubRole] = useState("");
  const [timezone, setTimezone] = useState("");
  const [picture, setPicture] = useState(null);
  const [students, setStudents] = useState([]);
  const [countryId, setCountryId] = useState(0);
  const [classTool, setClassTool] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [countries, setCountries] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [userPhones, setUserPhones] = useState([]);
  const [alerttitle, setAlertTitle] = useState("");
  const [openalert, setOpenAlert] = useState(false);
  const [classToolId, setClassToolId] = useState("");
  const [isTraining, setIsTraining] = useState(false);
  const [customGroups, setCustomGroups] = useState([]);
  const [firstAccess, setFirstAccess] = useState(false);
  const [openmodalpass, setOpenModalPass] = useState(false);
  const [globallanguages, setGlobalLanguages] = useState([]);
  const [alertdescription, setAlertDescription] = useState("");
  const [inputCustomGroup, setInputCustomGroup] = useState("");
  const [studentPlanLanguages, setStudentPlanLanguages] = useState([]);
  const [userEmails, setUserEmails] = useState([{ email: "", notify: true }]);
  const [languages, setLanguages] = useState([{ languageId: 0, isNative: true }]);
  const [bilingueNativo, setBilingueNativo] = useState({ bilingue: false, nativo: true });

  const callApi = (showModal) => {
    if (!showModal) {
      dispatch(getCountries()).then((res) => res && setCountries(res));
      dispatch(getGlobalLanguages()).then((res) => setGlobalLanguages(res));
    }

    let urlCall = `studentManagement/getbyuser/${id}`;

    dispatch(getAdminUserInfo(urlCall))
      .then(async (res) => {
        if (!res.success || !res.result.items || res.result.items.length === 0) return;

        const item = res?.result?.items[0];

        if (item.students && item.students.length > 0) {
          item.languages = item.students[0].studentLanguages;
          item.classTool = item.students[0].classTool;
          item.classToolId = item.students[0].classToolId;
        }

        if (item.languages && item.languages.length > 0) {
          item.languages.sort((x, y) => (x.isNative === y.isNative ? 0 : x.isNative ? -1 : 1));
        } else if (item.languages && item.languages.length === 0) {
          item.languages = [{ languageId: 0, isNative: true }];
        }

        if (item.userPhones.length === 0) item.userPhones = [{ userPhoneTypeId: 15, phone: "" }];
        if (item.picture !== null) item.oldPicture = item.picture;

        let emailsForm = [];

        if (item?.email) {
          emailsForm.push({ email: decryptIfEncrypted(item?.email), notify: true });

          if (item?.userEmails.length > 0) {
            item?.userEmails.forEach(
              (item) =>
                item?.email !== item.email &&
                emailsForm.push({ email: decryptIfEncrypted(item.email), notify: item.notify }),
            );
          }
        }

        const responseUserPhones = item?.userPhones?.map((item) => {
          return { ...item, phone: decryptIfEncrypted(item.phone) };
        });

        const responseLanguages = item?.languages?.map((item) => {
          if (!item.language) return item;
          return { ...item, language: { ...item.language, name: decryptIfEncrypted(item.language.name) } };
        });

        setUserEmails(emailsForm);
        setLanguages(responseLanguages);
        setUserPhones(responseUserPhones);

        setIdUser(item?.id);
        setIsActive(item?.active);
        setPicture(item?.picture);
        setTimezone(item?.timezone);
        setStudents(item?.students);
        setCountryId(item?.countryId);
        setClassTool(item?.classTool);
        setClassToolId(item?.classToolId);
        setFirstAccess(item?.firstAccess);
        setName(decryptIfEncrypted(item?.name));
        setEmail(decryptIfEncrypted(item?.email));
        setGender(decryptIfEncrypted(item?.gender));
        setAddress(decryptIfEncrypted(item?.address));
        setCpnCode(decryptIfEncrypted(item?.cpnCode));
        setBirthDate(decryptIfEncrypted(item?.birthDate));
        setIsTraining(item?.students[0]?.isTraining === null ? false : item?.students[0]?.isTraining);
        setBilingueNativo({
          bilingue: item?.students[0]?.typeTeacherPreference === "bilingual" ? true : false,
          nativo: item?.students[0]?.typeTeacherPreference === "native" ? true : false,
        });

        setSubRole(item?.subrole ?? "");
        setCustomGroups(item?.customgroup ? item?.customgroup.split(",") : []);

        if (showModal) {
          setOpenAlert(true);
          setAlertTitle(t("SAVE_FORM_TITLE"));
          setAlertDescription(t("SAVE_FORM_DESCRIPTION"));
        }

        await dispatch(getStudentManagement({ login: item?.email })).then((res) => {
          setStudentPlanLanguages(res.result.items[0].plans);
          setIsActive(
            res.result.items[0]?.plans[0]?.B2BStatus ||
              (res.result.items[0]?.plans[0]?.B2BStatus === "Active" && true) ||
              (res.result.items[0]?.plans[0]?.B2BStatus === "Cancelled" && false),
          );
        });
      })
      .catch((err) => console.log("ERRO GET USERS ", err));
  };

  const closeAlert = () => setOpenAlert(false);

  const addCustomGroup = (e) => {
    e.preventDefault();

    if (inputCustomGroup.trim() !== "") {
      setInputCustomGroup("");
      setCustomGroups([...customGroups, inputCustomGroup.trim()]);
    }
  };

  const removeCustomGroup = (indexToRemove) => {
    setCustomGroups(customGroups.filter((_, index) => index !== indexToRemove));
  };

  const addEmail = (e) => {
    e.preventDefault();
    setUserEmails((state) => [...state, { email: "", notify: true }]);
  };

  const addPhone = (e) => {
    e.preventDefault();
    setUserPhones((state) => [...state, { userPhoneTypeId: "", phone: "" }]);
  };

  const removeEmail = (e, findIndex) => {
    e.preventDefault();
    setUserEmails(userEmails.filter((value, index) => index !== findIndex));
  };

  const addLanguage = (e) => {
    e.preventDefault();
    setLanguages((state) => [...state, { languageId: 0, isNative: false }]);
  };

  const removeLanguage = (e, findIndex) => {
    e.preventDefault();
    setLanguages(languages.filter((value, index) => index !== findIndex));
  };

  const removePhone = (e, findIndex) => {
    e.preventDefault();
    setUserPhones(userPhones.filter((value, index) => index !== findIndex));
  };

  const handleChangeList = async (e, index) => {
    e.preventDefault();

    const { name, value } = e.target;

    if (name === "email") {
      if (index === 0) setEmail(value);
      setUserEmails((state) => state.map((item, i) => (i === index ? { ...item, email: value } : item)));
    }

    if (name === "notify") {
      setUserEmails((state) => state.map((item, i) => (i === index ? { ...item, notify: !item.notify } : item)));
    }

    if (name === "phone") {
      setUserPhones((state) => state.map((item, i) => (i === index ? { ...item, phone: value } : item)));
    }

    if (name === "userPhoneTypeId") {
      setUserPhones((state) => state.map((item, i) => (i === index ? { ...item, userPhoneTypeId: value } : item)));
    }

    if (name === "language") {
      setLanguages((state) =>
        state.map((item, i) => (i === index ? { languageId: value, isNative: index === 0 ? true : false } : item)),
      );
    }
  };

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;

    switch (target.name) {
      case "name":
        setName(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "gender":
        setGender(value);
        break;
      case "birthDate":
        setBirthDate(value);
        break;
      case "countryId":
        setCountryId(value);
        break;
      case "classToolId":
        setClassToolId(value);
        break;
      case "address":
        setAddress(value);
        break;
      case "classTool":
        setClassTool(value);
        break;
      case "cpnCode":
        setCpnCode(value);
        break;
      case "subRole":
        setSubRole(value);
        break;
      default:
        break;
    }
  };

  const validateForms = () => {
    if (name.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("NAME") }));

      return false;
    } else if (!/^\S+@\S+\.\S+$/.test(email) || email.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("EMAIL") }));

      return false;
    } else if (languages[0].languageId === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("NATIVE_LANGUAGE") }));

      return false;
    } else if (countryId <= 0) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("COUNTRY") }));

      return false;
    } else if (timezone.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("TIMEZONE") }));

      return false;
    } else if (classTool === "Select") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("CLASS_TOOL") }));

      return false;
    } else if (classToolId === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("TOOL_ID") }));

      return false;
    } else if (userPhones.length === 0 || userPhones[0].phone.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("CELLPHONE") }));

      return false;
    } else if (userPhones.length === 0 || userPhones[0].userPhoneTypeId === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("TYPE") }));

      return false;
    } else return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForms()) {
      let formData = {
        id: Number(id),
        address: address,
        cpnCode: cpnCode,
        name: name.toString(),
        isTraining: isTraining,
        email: email.toLowerCase(),
        countryId: Number(countryId),
        role: "student",
        gender: gender,
        birthDate: birthDate,
        timezone: timezone,
        userEmails: userEmails,
        firstAccess: false,
        userPhones: userPhones,
        classTool: classTool,
        classToolId: classToolId,
        typeLanguage: bilingueNativo.bilingue ? "bilingual" : "native",
      };

      let newlanguages = languages;
      if (newlanguages && languages.length > 0) {
        const nativeLanguages = newlanguages.filter((l) => l.isNative);
        if (nativeLanguages.length !== 1) {
          for (let index = 0; index < newlanguages.length; index++) {
            newlanguages[index].isNative = false;
          }
          newlanguages[0].isNative = true;
        }
      }

      let urlCall = `studentManagement/updatePersonalInformation`;

      if (students && students.length > 0) {
        let student = students[0];
        (student.active = isActive), (student.studentLanguages = newlanguages);
        student.languages = newlanguages;
        formData.student = student;
        student.classTool = classTool;
        student.classToolId = classToolId;
        formData.subrole = subRole;

        if (subRole === "SquadManager" || subRole === "b2bStudent") formData.customgroup = customGroups.join(", ");
        else formData.customgroup = "";

        if (isAuthenticated && firstAccess) formData.firstAccess = false;
      }

      formData.userEmails?.map((email) => {
        delete email.id;
        delete email.userId;
        delete email.updatedAt;
        delete email.createdAt;
        delete email.deletedAt;
        delete email.userPhoneType;
      });

      formData.userPhones.map((phone) => {
        delete phone.id;
        delete phone.userId;
        delete phone.updatedAt;
        delete phone.createdAt;
        delete phone.deletedAt;
        delete phone.userPhoneType;
      });

      dispatch(updateUserInfo(urlCall, JSON.parse(JSON.stringify(formData))), "student")
        .then((res) => {
          if (!res || !res.success) return;

          callApi(true);
        })
        .catch((error) => {
          setOpenAlert(true);
          setAlertTitle(t("ERROR"));
          setAlertDescription(error);
        });
    }
  };

  const openModalPassword = () => setOpenModalPass(true);

  const handleClickBilingueNativo = (e, type) => {
    e.preventDefault();

    if (type === "bilingue") setBilingueNativo({ bilingue: true, nativo: false });
    else setBilingueNativo({ bilingue: false, nativo: true });
  };

  const handleIsActiveStudent = (e) => {
    e.preventDefault();

    const body = {
      studentPlanId: studentPlanLanguages[0]?.studentPlanId,
      status: !isActive,
    };

    dispatch(updateStatusStudentB2B(body))
      .then((res) => res.success && setIsActive((state) => !state))
      .catch((error) => {
        setOpenAlert(true);
        setAlertTitle(t("ERROR"));
        setAlertDescription(error?.response?.data?.message);
      });
  };

  useEffect(() => {
    callApi(false);
    // eslint-disable-next-line
  }, []);

  const nativeLanguage = languages?.find((item) => item.isNative);
  const validationLanguageNative = nativeLanguage ? nativeLanguage.languageId : null;

  let dataNew = moment(new Date()).utc().tz(timezone);
  let dataTimeZone = dataNew && dataNew.format(timeDisplayFormatFunction("12"));

  return (
    <div className="view">
      <PersonalInfoStyled>
        <div className="tabs">
          {name !== "" || idUser !== 0 ? (
            <div className="tab-content">
              <div className="box">
                <PhotoAvatar userID={id} picture={picture} setPicture={setPicture} />

                <form className="formulario">
                  <div className="wrapperBlock">
                    <h4 className="textBlock">{t("PERSONAL_DATA")}</h4>
                  </div>

                  <div>
                    <div>
                      <label htmlFor="name" required={validations["name"]}>
                        {t("NAME")}
                      </label>
                      <span className="invalid">{validations["name"] && t("REQUIRED_FIELD")}</span>
                    </div>
                    <input
                      required
                      id="name"
                      type="text"
                      name="name"
                      value={name}
                      onChange={handleChange}
                      placeholder={t("NAME_PLACEHOLDER")}
                    />
                  </div>

                  {userEmails.length &&
                    userEmails?.map((item, index) => {
                      return (
                        <div key={index}>
                          <div>
                            <label htmlFor={"email" + index}>{index === 0 ? t("EMAIL") : t("EXTRA_EMAIL")} </label>
                          </div>
                          <div className="notification">
                            <input
                              required
                              type="text"
                              name="email"
                              autoComplete="none"
                              id={"email" + index}
                              className="newemail inputMobile"
                              placeholder={index === 0 ? t("EMAIL_PLACEHOLDER") : t("EXTRA_EMAIL_PLACEHOLDER")}
                              value={item.email}
                              onChange={(e) => {
                                if (index === 0) {
                                  handleChange(e);
                                }
                                handleChangeList(e, index);
                              }}
                            />
                            <div className="switchBox">
                              <div className="switch__container">
                                <input
                                  className="switch switch--shadow"
                                  name="notify"
                                  id={"notify" + index}
                                  type="checkbox"
                                  onChange={(e) => handleChangeList(e, index)}
                                  checked={item.notify}
                                />
                                <label className="labelNotify" htmlFor={"notify" + index}>
                                  <span>{t("NOTIFICATION")}</span>
                                  <span className="doubleClick">{t("DOUBLE_CLICK")}</span>
                                </label>
                              </div>
                            </div>
                            {index > 0 ? (
                              <SCButtonAddInput id={index} name="remove" onClick={(e) => removeEmail(e, index)}>
                                {t("DELETE")} <i className="fa fa-times-circle-o fa-lg"></i>
                              </SCButtonAddInput>
                            ) : (
                              <SCButtonAddInput name="addemail" onClick={(e) => addEmail(e)}>
                                {t("ADD_EMAIL")} +
                              </SCButtonAddInput>
                            )}
                          </div>
                        </div>
                      );
                    })}

                  <div className="inputs">
                    <div className="lineInputs">
                      <div>
                        <label htmlFor="gender">{t("GENDER")}</label>
                        <span className="invalid">{validations["gender"] && t("REQUIRED_FIELD")}</span>
                      </div>
                      <select name="gender" value={gender} onChange={handleChange}>
                        <option value="">{t("SELECT")}</option>
                        <option value="notInformed">{t("NOT_INFORMED")}</option>
                        <option value="male">{t("MALE")}</option>
                        <option value="female">{t("FEMALE")}</option>
                      </select>
                    </div>

                    <div className="lineInputs">
                      <div>
                        <label htmlFor="birthDate">{t("BIRTH_DATE")}</label>
                        <span className="invalid">{validations["birthday"] && t("REQUIRED_FIELD")}</span>
                      </div>

                      <input type="date" id="date" name="birthDate" value={birthDate} onChange={handleChange} />
                    </div>
                  </div>

                  <div className="wrapperBlock">
                    <h4 className="textBlock">{t("COUNTRY")}</h4>
                  </div>

                  <div className="inputs">
                    <div className="lineInputs">
                      <div>
                        <label htmlFor="countryId">{t("COUNTRY")}</label>
                        <span className="invalid">{validations["countryId"] && t("REQUIRED_FIELD")}</span>
                      </div>
                      <select name="countryId" value={countryId} onChange={handleChange}>
                        <option value="0">Select</option>
                        {countries.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="inputs">
                    <div className="lineInputs timezoneCard">
                      <div>
                        <label htmlFor="timezone">{t("TIMEZONE")} </label>
                        <span className="invalid">{validations["timezone"] && t("REQUIRED_FIELD")}</span>
                      </div>
                      <TimezonePicker
                        value={timezone}
                        onChange={(timezoneName) => setTimezone(timezoneName)}
                        inputProps={{
                          placeholder: "Select Timezone...",
                          name: "timezone",
                        }}
                      />
                    </div>
                    <div className="lineInputs">
                      <p>
                        {t("CURRENT_TIME")}
                        <br /> {t("IN_THIS_TIMEZONE")}: {dataTimeZone}
                      </p>
                    </div>
                  </div>

                  <div>
                    <label htmlFor="address">{t("ADDRESS")} </label>
                    <span className="invalid">{validations["address"] && t("REQUIRED_FIELD")}</span>
                  </div>
                  <input
                    placeholder={t("ADDRESS_PLACEHOLDER")}
                    name="address"
                    value={address}
                    onChange={handleChange}
                    required
                  />

                  {userPhones.map((item, index) => {
                    return (
                      <div key={index} className="inputs telefone">
                        <div className="lineInputs">
                          <div>
                            <label htmlFor={"phone" + index}>{t("TELEPHONE")}</label>
                            {index === 0 && (
                              <span className="invalid">{validations["phone"] && t("REQUIRED_FIELD")}</span>
                            )}
                          </div>
                          <input
                            id={"phone" + index}
                            className="inputMobile"
                            required={index === 0}
                            placeholder={t("PHONE_PLACEHOLDER")}
                            name="phone"
                            value={item.phone}
                            onChange={(e) => handleChangeList(e, index)}
                          />
                        </div>
                        <div className="lineInputs">
                          <div>
                            <label htmlFor={"userPhoneTypeId" + index}>{t("TYPE")}</label>
                          </div>
                          <select
                            name="userPhoneTypeId"
                            id={"phoneType" + index}
                            className="inputMobile"
                            value={item.userPhoneTypeId || 15}
                            onChange={(e) => handleChangeList(e, index)}
                          >
                            <option value="15">{t("SELECT")}</option>
                            <option value="1">{t("COMMERCIAL")}</option>
                            <option value="2">{t("RESIDENCIAL")}</option>
                            <option value="3">{t("CELLPHONE")}</option>
                            <option value="4">{t("WHATSAPP")}</option>
                          </select>
                        </div>
                        {index === 0 && (
                          <div className="lineInputs">
                            <SCButtonAddInput name="addphone" onClick={(e) => addPhone(e)}>
                              {t("BTN_ADD_TEL")} +
                            </SCButtonAddInput>
                          </div>
                        )}
                        {index > 0 && (
                          <SCButtonAddInput id={index} name="remove" onClick={(e) => removePhone(e, index)}>
                            {t("DELETE")} <i className="fa fa-times-circle-o fa-lg"></i>
                          </SCButtonAddInput>
                        )}
                      </div>
                    );
                  })}

                  <div className="wrapperBlock">
                    <h4 className="textBlock">{t("CLASS_LINK")}</h4>
                  </div>

                  <div className="inputs">
                    <div className="lineInputs">
                      <InputForClassTool
                        name="classTool"
                        data={{ value: classTool, required: false }}
                        inputChange={handleChange}
                        readonly="readonly"
                        tabindex="-1"
                        aria-disabled="true"
                      />
                    </div>
                    <div className="lineInputs">
                      <div>
                        <label htmlFor="classToolId">{t("TOOL_ID")}</label>
                        <span className="invalid">{validations["classToolId"]}</span>
                      </div>

                      <input
                        placeholder={t("STUDENT_TOOL_ID")}
                        id="classToolId"
                        className="classToolId"
                        name="classToolId"
                        value={classToolId}
                        onChange={handleChange}
                        disabled={user?.role === "companyManager" || user?.role === "customerService" ? false : true}
                      />
                    </div>
                  </div>

                  <div>
                    <div className="wrapperBlock">
                      <h4 className="textBlock">{t("TEACHER")}</h4>
                    </div>

                    <div className="wrapperSelectTeacher">
                      <button
                        onClick={(e) => handleClickBilingueNativo(e, "nativo")}
                        className={`buttonSelectTeacher ${bilingueNativo.nativo && "buttonSelectTeacherActive"}`}
                      >
                        {t("NATIVE")}
                      </button>
                      <button
                        onClick={(e) => handleClickBilingueNativo(e, "bilingue")}
                        className={`buttonSelectTeacher ${bilingueNativo.bilingue && "buttonSelectTeacherActive"}`}
                      >
                        {t("BILINGUAL")}
                      </button>

                      <Popup
                        on={"hover"}
                        position={"right center"}
                        style={{ width: 300, backgroundColor: "red" }}
                        trigger={<img className="linguitoPNG" src={linguitoPNG} />}
                      >
                        <div style={{ width: 300 }}>
                          <p style={{ textAlign: "justify", color: "#555D67" }}>{t("MESSAGE_INFO_BILINGUE_NATIVO")}</p>
                        </div>
                      </Popup>
                    </div>
                  </div>

                  {user?.role === "companyManager" && (
                    <div>
                      <div className="wrapperBlock">
                        <h4 className="textBlock">{t("PAYMENT").concat(" CPN")}</h4>
                      </div>

                      <div>
                        <label>CPN Code</label>
                      </div>
                      <input required name="cpnCode" value={cpnCode} placeholder="cpnCode" onChange={handleChange} />
                    </div>
                  )}

                  <div>
                    <div className="wrapperBlock">
                      <h4 className="textBlock">{t("DEPARTMENT")}</h4>
                    </div>

                    <div className="inputs">
                      <div className="lineInputs">
                        <div>
                          <label htmlFor="language">SubRole</label>
                          <span className="invalid">{validations["nativelanguage"] && t("REQUIRED_FIELD")}</span>
                        </div>
                        <div>
                          <select
                            name="subRole"
                            value={subRole}
                            onChange={handleChange}
                            className="language inputMobile"
                          >
                            <option value="">{t("SELECT")}</option>
                            <option value={"EconomicGroup"}>EconomicGroup</option>
                            <option value={"CompanyManager"}>CompanyManager</option>
                            <option value={"ContractManager"}>ContractManager</option>
                            <option value={"SquadManager"}>SquadManager</option>
                            <option value={"b2bStudent"}>b2bStudent</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    {(subRole === "SquadManager" || subRole === "b2bStudent") && (
                      <div className="lineInputs">
                        <div>
                          <label htmlFor="language">CustomGroup</label>
                          <span className="invalid">{validations["nativelanguage"] && t("REQUIRED_FIELD")}</span>
                        </div>
                        <div>
                          <div style={{ display: "flex", gap: 4 }}>
                            <input
                              type="text"
                              style={{ width: 200 }}
                              value={inputCustomGroup}
                              placeholder="Digite algo..."
                              onChange={(e) => setInputCustomGroup(e.target.value)}
                            />
                            <div style={{ marginTop: 2 }}>
                              <SCButtonAddInput name="addCustomGroup" onClick={addCustomGroup}>
                                Add CustomGroup +
                              </SCButtonAddInput>
                            </div>
                          </div>

                          <div className="customGroups-list">
                            {customGroups.map((tag, index) => (
                              <div key={index} className="customGroups">
                                <span className="text-sm font-medium">{tag}</span>
                                <button type="button" onClick={() => removeCustomGroup(index)} className="remove-btn">
                                  <i className="fa fa-times-circle-o fa-lg" />
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div>
                    <div className="wrapperBlock">
                      <h4 className="textBlock">{t("LANGUAGE")}</h4>

                      <button name="addlanguage" className="addInput" onClick={(e) => addLanguage(e)}>
                        {t("ADD_LANGUAGE")} +
                      </button>
                    </div>

                    <div className="wrapperLanguage">
                      <div
                        className="languageMain"
                        style={languages?.filter((item) => !item.isNative).length === 0 ? { marginBottom: 25 } : {}}
                      >
                        <div>
                          <label htmlFor="language">{t("NATIVE_LANGUAGE")}</label>
                          <span className="invalid">{validations["nativelanguage"] && t("REQUIRED_FIELD")}</span>
                        </div>
                        <div>
                          <select
                            name="language"
                            className="language inputMobile"
                            onChange={(e) => handleChangeList(e, 0)}
                            value={validationLanguageNative ? validationLanguageNative : ""}
                          >
                            <option value="">{t("SELECT")}</option>
                            {globallanguages.map((item) => (
                              <option key={"nativ" + item.id} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {languages?.filter((item) => !item.isNative).length !== 0 && <div className="divSeparation" />}

                      <div className="otherLanguage">
                        {languages?.filter((item) => !item.isNative).length !== 0 && (
                          <div className="wrapperLabel">
                            <label>{t("OTHER_LANGUAGE")}</label>
                          </div>
                        )}

                        <div className="wrapperOtherLanguage">
                          {languages
                            ?.filter((item) => !item.isNative)
                            ?.map((item, index) => {
                              if (user?.role === "student" || (index >= 0 && user?.role !== "student"))
                                index = index + 1;
                              return (
                                <div key={index}>
                                  <div style={{ marginTop: -13, display: "flex" }}>
                                    <select
                                      name="language"
                                      id={"language" + index}
                                      value={item.languageId}
                                      className="language inputMobile"
                                      onChange={(e) => handleChangeList(e, index)}
                                    >
                                      <option value="">{t("SELECT")}</option>
                                      {globallanguages.map((item) => (
                                        <option key={"gLang" + item.id} value={item.id}>
                                          {item.name}
                                        </option>
                                      ))}
                                    </select>

                                    <button
                                      id={index}
                                      name="removelanguage"
                                      className="buttonRemovelanguage"
                                      onClick={(e) => removeLanguage(e, index)}
                                    >
                                      X
                                    </button>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="wrapperConfigButtons">
                    {studentPlanLanguages[0]?.B2BStudentId && (
                      <>
                        {user?.role === "companyManager" && (
                          <div className="lineInputs">
                            <label htmlFor="isActive">{t("ISACTIVE")}</label>

                            <div className="switch__container">
                              <input
                                type="checkbox"
                                name="isActive"
                                checked={isActive}
                                id="switch-shadow3"
                                onChange={handleIsActiveStudent}
                                className="switch switch--shadow2"
                              />
                              <label htmlFor="switch-shadow3">{t("YES")}</label>
                            </div>
                          </div>
                        )}

                        <div className="lineInputs">
                          <label htmlFor="isActive">{t("TRAINING")}</label>
                          <div className="switch__container">
                            <input
                              type="checkbox"
                              name="isActive"
                              id="switch-shadow4"
                              checked={isTraining}
                              className="switch switch--shadow2"
                              onChange={() => setIsTraining((state) => !state)}
                            />
                            <label htmlFor="switch-shadow4">{t("YES")}</label>
                          </div>
                        </div>
                      </>
                    )}

                    <div>
                      <div>
                        <label htmlFor="password">{t("PASSWORD")}</label>
                        {firstAccess && (
                          <span className="invalid">{validations["address"] && t("REQUIRED_FIELD")}</span>
                        )}
                      </div>
                      <button type="button" className="password" onClick={openModalPassword}>
                        {t("CHANGE_PASSWORD")}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div className="buttonSave">
                <button className="back" onClick={() => navigate(-1)}>
                  <i className="fa fa-angle-left" aria-hidden="true"></i> {t("BTN_BACK")}
                </button>
                <button type="submit" className="button-save" onClick={handleSubmit}>
                  {t("BTN_SAVE")}
                </button>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </PersonalInfoStyled>

      <Dialog
        open={openalert}
        onClose={closeAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="boxModal"
      >
        <DialogTitle id="alert-dialog-title">
          <span className="titleModal">{alerttitle}</span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="pass-dialog-description" className="boxModal">
            <span className="formulario">
              <span className="description">{alertdescription}</span>
            </span>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <div className="buttons">
            <button onClick={closeAlert} color="primary" autoFocus>
              {t("CLOSE")}
            </button>
          </div>
        </DialogActions>
      </Dialog>

      <ModalChangePassword id={id} showModal={openmodalpass} setShowModal={setOpenModalPass} />
    </div>
  );
}

export default PersonalInfo;
